"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodsBanner = void 0;
var root_1 = require("./root");
Object.defineProperty(exports, "PaymentMethodsBanner", { enumerable: true, get: function () { return root_1.PaymentMethodsBannerLazyRoot; } });
//# sourceMappingURL=index.js.map